// Injects a JSON-LD LocalBusiness schema into <head> for SEO / AI search.
// Place once globally in the app so all pages benefit.
import { useEffect } from "react";

export default function LocalBusinessSchema() {
  useEffect(() => {
    const schema = {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "@id": "https://mediafly-production.de/#business",
      name: "MediaFly Production",
      legalName: "MediaFly Production – Emre Ucar",
      founder: { "@type": "Person", name: "Emre Ucar" },
      description:
        "Cinematic Social Media & Reel Production aus dem Rhein-Main-Gebiet. Professionelle Reel-Produktion und Videografie in Frankfurt, Aschaffenburg, Darmstadt, Offenbach, Hanau, Wiesbaden und Mainz.",
      image:
        (typeof window !== "undefined" ? window.location.origin : "") + "/brand/MFP_white.svg",
      logo:
        (typeof window !== "undefined" ? window.location.origin : "") + "/brand/MFP_white.svg",
      url: "https://mediafly-leads.emergent.host/",
      telephone: "+49 170 4444355",
      email: "anfragen@mediafly-production.de",
      priceRange: "€€",
      address: {
        "@type": "PostalAddress",
        streetAddress: "Am Obereich 56",
        postalCode: "64832",
        addressLocality: "Babenhausen",
        addressRegion: "Hessen",
        addressCountry: "DE",
      },
      areaServed: [
        { "@type": "City", name: "Frankfurt am Main" },
        { "@type": "City", name: "Aschaffenburg" },
        { "@type": "City", name: "Darmstadt" },
        { "@type": "City", name: "Offenbach" },
        { "@type": "City", name: "Hanau" },
        { "@type": "City", name: "Wiesbaden" },
        { "@type": "City", name: "Mainz" },
        { "@type": "AdministrativeArea", name: "Rhein-Main-Gebiet" },
      ],
      sameAs: [],
      contactPoint: [
        {
          "@type": "ContactPoint",
          telephone: "+49 170 4444355",
          email: "anfragen@mediafly-production.de",
          contactType: "customer service",
          areaServed: "DE",
          availableLanguage: ["German", "English"],
        },
      ],
    };
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "mfp-localbusiness-schema";
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);
    return () => {
      const existing = document.getElementById("mfp-localbusiness-schema");
      if (existing) existing.remove();
    };
  }, []);

  return null;
}
